import { isEmpty } from 'underscore'
import { getValue } from '@/services/persistence.js'
import { isLocal, warnOnce } from '@/services/environment.js'

export const detectShop = () => {
  // localStorage SHOP forces the shop, on local hosts only (ADR-0061)
  let hostname
  if (isLocal()) {
    const lsValue = getValue('SHOP')
    if (!isEmpty(lsValue)) {
      hostname = lsValue
      warnOnce(`localStorage SHOP forces the shop ${lsValue} on ${window.location.hostname}`)
    }
  }

  // fallback by hostname
  if (!hostname) hostname = window.location.hostname
  if (hostname.toUpperCase().includes('ELNA')) return 'ELNA'
  if (hostname.toUpperCase().includes('HANDIQUILTER')) return 'HANDIQUILTER'
  if (hostname.toUpperCase().includes('JACK')) return 'JACK'
  if (hostname.toUpperCase().includes('JUKI')) return 'JUKI'
  if (hostname.toUpperCase().includes('NECCHI')) return 'NECCHI'
  if (hostname.toUpperCase().includes('IDEASPATCH')) return 'IDEASPATCH'

  // fallback value
  return 'JPUJOL'
}
